import React from 'react';

import * as calssnames from 'classnames';

import './styles.scss';

const Title = ({text, isLight, isBig, isExtra, isCard, isTexStart, isBold, isWhite, isPaddingBottom, isBottomLine, isMainBig, isPaddingTop }) => {
	return (
		<h2
			className={
				calssnames('main-title',{
					"main-title--light": isLight,
					"main-title--big": isBig,
					"main-title--extra": isExtra,
					"main-title--card": isCard,
					"main-title--tex-start": isTexStart,
					"main-title--bold": isBold,
					"main-title--white": isWhite,
					"main-title--mainBig": isMainBig,
					"main-title--isPaddingTop": isPaddingTop,
					"main-title--isPaddingBottom": isPaddingBottom,
					"main-title--isBottomLine": isBottomLine,
				})
			}
		>
			{text}
		</h2>
	);
};

export default Title;
